import React from 'react';
import { Route } from 'react-router-dom';
import Dataviewcard from '../../Data-View/dataviewcard.js';
import Viewhospital from '../../Data-View/DataviewFile/Hospital.js';
import Viewscanningcenter from '../../Data-View/DataviewFile/ScanningCenter.js';
import CelebrityHome from '../../Data-View/DataviewFile/CelebrityHome.js';
import Malldetails from '../../Data-View/DataviewFile/Mall.js';
import Hoteldata from '../../Data-View/DataviewFile/StarHotel.js';
import { guardRoute } from '../ProtectedRoute';

export const dataViewRoutes = [
  <Route
    key="dataview-card"
    path="/dataviewcard"
    element={guardRoute(<Dataviewcard />, '/dataviewcard')}
  />,
  <Route
    key="view-hospital"
    path="/Viewhospital"
    element={guardRoute(<Viewhospital />, '/Viewhospital')}
  />,
  <Route
    key="view-scanning"
    path="/Viewscanningcenter"
    element={guardRoute(<Viewscanningcenter />, '/Viewscanningcenter')}
  />,
  <Route
    key="celebrity-home"
    path="/CelebrityHome"
    element={guardRoute(<CelebrityHome />, '/CelebrityHome')}
  />,
  <Route
    key="mall-details"
    path="/Malldetails"
    element={guardRoute(<Malldetails />, '/Malldetails')}
  />,
  <Route key="hotel-data" path="/Hoteldata" element={guardRoute(<Hoteldata />, '/Hoteldata')} />,
];
